import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { IconButton, cn } from '../../../ui';
import { initialsOf } from '../studentHomeRules';

/** The student's photo on the brand fill, with the way to change it. A photo that
 *  will not load (its signed link expired) falls back to initials, not a broken box. */
const ProfileAvatar = ({ name, src, className }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);

  return (
    <div className={cn('tw-relative tw-shrink-0', className)}>
      <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border-[3px] tw-border-solid tw-border-primary-solid-fg/70 tw-bg-primary-solid-fg/15 tw-text-xl tw-font-medium">
        {src && !failed
          ? <img src={src} alt="" className="tw-h-full tw-w-full tw-object-cover" onError={() => setFailed(true)} />
          : <span aria-hidden="true">{initialsOf(name)}</span>}
      </div>
      <span className="tw-absolute tw--bottom-1 tw--right-1 tw-flex">
        <IconButton
          as={Link}
          to="/s/account-settings"
          label="Edit profile"
          icon={Pencil}
          variant="outline"
          size="sm"
          className="tw-rounded-full tw-border-primary tw-bg-surface-raised tw-text-primary tw-no-underline tw-shadow-card hover:tw-bg-surface-raised hover:tw-text-primary"
        />
      </span>
    </div>
  );
};

export default ProfileAvatar;
